/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100MaintenanceModeException } from './Ptw100MaintenanceModeException';
import {
    Ptw100MaintenanceModeExceptionFromJSON,
    Ptw100MaintenanceModeExceptionFromJSONTyped,
    Ptw100MaintenanceModeExceptionToJSON,
} from './Ptw100MaintenanceModeException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100MaintenanceModeException
 */
export interface ErrorResponseOfPtw100MaintenanceModeException {
    /**
     * This code is used in the ExceptionMiddleware and will be set as the HTTP response status code
     * @type {number}
     * @memberof ErrorResponseOfPtw100MaintenanceModeException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100MaintenanceModeException}
     * @memberof ErrorResponseOfPtw100MaintenanceModeException
     */
    exception: Ptw100MaintenanceModeException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100MaintenanceModeException
     */
    $type?: ErrorResponseOfPtw100MaintenanceModeExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100MaintenanceModeExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100MaintenanceModeExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100MaintenanceModeException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100MaintenanceModeExceptionTypeEnum = typeof ErrorResponseOfPtw100MaintenanceModeExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100MaintenanceModeExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100MaintenanceModeException interface.
 */
export function instanceOfErrorResponseOfPtw100MaintenanceModeException(value?: unknown): value is ErrorResponseOfPtw100MaintenanceModeException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100MaintenanceModeExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(json: any): ErrorResponseOfPtw100MaintenanceModeException {
    return ErrorResponseOfPtw100MaintenanceModeExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100MaintenanceModeExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100MaintenanceModeException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100MaintenanceModeExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100MaintenanceModeExceptionToJSON(value?: Omit<ErrorResponseOfPtw100MaintenanceModeException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100MaintenanceModeExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

